function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import { isNonEmptyArray, matchList, ONE_KIBI_BYTE, safeTruncate } from '@datadog/browser-core';
/**
 * arbitrary value, byte precision not needed
 */

var GRAPHQL_PAYLOAD_LIMIT = 32 * ONE_KIBI_BYTE;
export function extractGraphQlMetadata(request, graphQlConfig) {
  var metadata = extractGraphQlRequestMetadata(request.requestBody, graphQlConfig.trackPayload);

  if (!metadata) {
    return;
  }

  if (graphQlConfig.trackResponseErrors && request.responseBody) {
    var responseErrors = parseGraphQlResponse(request.responseBody);

    if (responseErrors) {
      metadata.errors_count = responseErrors.length;
      metadata.errors = responseErrors;
    }
  }

  return metadata;
}
export function parseGraphQlResponse(responseText) {
  var response;

  try {
    response = JSON.parse(responseText);
  } catch (_a) {
    // Invalid JSON response
    return;
  }

  if (!response || _typeof(response) !== 'object') {
    return;
  }

  var responseObj = response;

  if (!isNonEmptyArray(responseObj.errors)) {
    return;
  }

  var errors = responseObj.errors.map(function (error) {
    var _a;

    var graphqlError = {
      message: error.message,
      path: error.path,
      locations: error.locations,
      code: (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code
    };
    return graphqlError;
  });
  return errors;
}
export function findGraphQlConfiguration(url, configuration) {
  return configuration.allowedGraphQlUrls.find(function (graphQlOption) {
    return matchList([graphQlOption.match], url);
  });
}
export function extractGraphQlRequestMetadata(requestBody) {
  var trackPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!requestBody || typeof requestBody !== 'string') {
    return;
  }

  var graphqlBody;

  try {
    graphqlBody = JSON.parse(requestBody);
  } catch (_a) {
    // Not valid JSON
    return;
  }

  if (!graphqlBody || !graphqlBody.query) {
    return;
  }

  var query = graphqlBody.query.trim();
  var operationType = getOperationType(query);
  var operationName = graphqlBody.operationName;

  if (!operationType) {
    return;
  }

  var variables;

  if (graphqlBody.variables) {
    variables = JSON.stringify(graphqlBody.variables);
  }

  return {
    operationType: operationType,
    operationName: operationName,
    variables: variables,
    payload: trackPayload ? safeTruncate(query, GRAPHQL_PAYLOAD_LIMIT, '...') : undefined
  };
}

function getOperationType(query) {
  var _a;

  return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}